import React, { createContext, useContext, useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import { io } from "socket.io-client"; // Import io function
import getStorageData from "./getStorageData";
import { MY_CHIP_DATA } from "../helpers/socketEvent";
import { useDispatch } from "react-redux";
import { getChipData } from "../store/slices/APIResponseSlice";

interface SocketContextProps {
  children: React.ReactNode;
}

const SocketContext = createContext<Socket | null>(null);

export const useSocket = (): Socket | null => {
  return useContext(SocketContext);
};

export const SocketProvider: React.FC<SocketContextProps> = ({ children }) => {
  const dispatch = useDispatch();
  const [socket, setSocket] = useState<Socket | any>(null);

  useEffect(() => {
    const newSocket: any = getStorageData().token
      ? (io(`https://data.whitelion.in/?token=${getStorageData().token}`, {
          reconnection: true, // Enable reconnection
          reconnectionDelay: 1000,
        }) as Socket)
      : "";

    if (newSocket) {
      newSocket.on("connect", () => {
        newSocket.on(MY_CHIP_DATA, (data: any) => {
          dispatch(getChipData(data));
        });
      });

      setSocket(newSocket);
    }

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
